module.exports = __webpack_public_path__ + "static/media/Logo_BID_sin bajada.61fb087c.png";